
import { CategoryInfo } from "./CategoryInfo";
import { FieldInfo } from "./FieldInfo";
import { ProductFieldInfo } from "./ProductFieldInfo";
 
import { ProductFieldInfoVisibility } from "./ProductFieldInfoVisibility";

export class RequiredFields {
  public categories?: CategoryInfo[];

  constructor() {
    this.categories = [];
  }

  /**
   * Get true if the sender’s legal ID is required (this is different from photo ID, usually SSN); otherwise false.
   */
  public get isSendersLegalIdRequired(): boolean {
    const fieldInfo = this.getField("senderLegalIdNumber");
    if (fieldInfo) {
      return fieldInfo.visibility === ProductFieldInfoVisibility.REQ;
    }
    return false;
  }

  /**
   * Gets the field that matches the provided tag name.
   * @param tagName The name of the field to look for.
   * @returns A FieldInfo object that matches the provided tag name or null.
   */
  public getField(tagName: string): FieldInfo | null {
    if (!tagName) {
      return null;
    }

    for (const cat of this.categories ?? []) {
      for (const field of cat.fields ?? []) {
        if (field.tagName?.toLowerCase() === tagName.toLowerCase()) {
          return field;
        }
      }
    }
    return null;
  }

  /**
   * Gets the category that matches the specified category name.
   * @param categoryName The name of the category.
   * @returns A CategoryInfo object that matches the provided name or null.
   */
  public getCategory(categoryName: string): CategoryInfo | null {
    if (this.categories && categoryName?.trim()) {
      return (
        this.categories.find(
          (x) =>
            x.categoryName?.toLowerCase() === categoryName.trim().toLowerCase()
        ) ?? null
      );
    }
    return null;
  }

  public getMissingFields(gffpFieldsByCategory: Record<string, any[]>, validationReq: any): any[] {
    const missingFields: ProductFieldInfo[] = [];
    // Build a case-insensitive view of validationReq keys
    const lowerKeyMap: Record<string, any> = {};
    if (validationReq && typeof validationReq === 'object') {
      for (const key of Object.keys(validationReq)) {
        lowerKeyMap[key.toLowerCase()] = (validationReq as any)[key];
      }
    }

    for (const category of Object.values(gffpFieldsByCategory)) {
      for (const field of category) {
        if (field.visibility === ProductFieldInfoVisibility.REQ) {
          const rawTag: string = String(field?.XmlTag ?? field?.xmlTag ?? '').trim();
          const tagLc = rawTag.toLowerCase();
          const hasKey = Object.prototype.hasOwnProperty.call(lowerKeyMap, tagLc);
          const value = hasKey ? lowerKeyMap[tagLc] : undefined;
          if (!value) {
            missingFields.push(field);
          }
        }
      }
    }
    return missingFields;
  }
}
